module.exports = __webpack_public_path__ + "static/media/leadForm_icon--active.b87bc86b.svg";